<div class="iframe-container">
  <iframe width="100%" height="100%" class="iframe" frameBorder="0" [src]="urlSafe"></iframe>
</div>

